import { Dimensions } from 'react-native';

const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;
 


export default {
  window: {
    width,
    height,
  },
  isExtraSmallDevice: width  <= 375,
  isSmallDevice: width > 375 && width <= 414,
  isMediumDevice:  width > 414 && width <= 768,
  isLargeDevice: width > 768 && width <= 1024,
  isExtraLargeDevice: width > 1024,

};
